// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"88":"b80f7f3c","110":"864c6be6","125":"c43ae721","180":"10d5a81a","344":"9e728fe4","453":"3bf93af1","468":"da1913ff","506":"9986b0de","598":"e8deb754","693":"4b118836","787":"ef334497","799":"c850df5c","853":"603080f6","958":"e6c7e799","962":"19a09e89"}[chunkId] + ".chunk.js";
};